import React from "react";

export default function WorksCardsX({img}) {
  return (

<div className="w-56 h-56 md:w-96 md:h-64 bg-gray-300">
<img src={img} alt="img" className="w-full h-full object-cover object-center"></img>
    </div>
  );
}
